import { Icon } from '@chakra-ui/react';

export const CustomCopyLinkIcon = (props) => {
  return (
    <Icon viewBox="0 0 17 17" fill="none" {...props}>
      <path
        d="M5.4576 11.1146L11.1146 5.4576M3.3356 7.5786L1.9216 8.9926C1.55016 9.36405 1.25551 9.80501 1.05449 10.2903C0.853466 10.7756 0.75 11.2958 0.75 11.8211C0.75 12.3464 0.853466 12.8666 1.05449 13.3519C1.25551 13.8372 1.55016 14.2782 1.9216 14.6496C2.29305 15.021 2.73401 15.3157 3.21933 15.5167C3.70464 15.7177 4.2248 15.8212 4.7501 15.8212C5.2754 15.8212 5.79556 15.7177 6.28088 15.5167C6.76619 15.3157 7.20716 15.021 7.5786 14.6496L8.9906 13.2356M7.5776 3.3356L8.9916 1.9216C9.36305 1.55016 9.80401 1.25551 10.2893 1.05449C10.7746 0.853466 11.2948 0.75 11.8201 0.75C12.3454 0.75 12.8656 0.853466 13.3509 1.05449C13.8362 1.25551 14.2772 1.55016 14.6486 1.9216C15.02 2.29305 15.3147 2.73401 15.5157 3.21933C15.7167 3.70464 15.8202 4.2248 15.8202 4.7501C15.8202 5.2754 15.7167 5.79556 15.5157 6.28088C15.3147 6.76619 15.02 7.20716 14.6486 7.5786L13.2346 8.9926"
        stroke="#4C4C4C"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </Icon>
  );
};
